import GeneralHead from "@logics/tags/GeneralHead";
import StackLayout from "@domains/common/views/layouts/StackLayout/StackLayout";
import Download from "@domains/intro/views/Download/Download";

const DownloadPage = () => {
  return (
    <>
      <GeneralHead />
      <StackLayout hideNavbar>
        <Download />
      </StackLayout>
    </>
  );
};

export default DownloadPage;
